import deLogo from 'icons/schools-logo-de.svg';
import esLogo from 'icons/schools-logo-es.svg';
import frLogo from 'icons/schools-logo-fr.svg';
import ptLogo from 'icons/schools-logo-pt.svg';
import enLogo from 'icons/schools-logo.svg';

import { SchoolLogos } from './types';

export const schoolsLogos: SchoolLogos = {
	en: enLogo,
	fr: frLogo,
	es: esLogo,
	de: deLogo,
	pt: ptLogo,
};
